module.exports = __webpack_public_path__ + "img/pr-4.3c2d18d7.png";